import { render, staticRenderFns } from "./divider-normal.mpx?vue&type=template&id=04d5dede&isComponent&outputPath=components%2Fdivider-normald57fe118%2Findex"
import script from "./divider-normal.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fdivider-normald57fe118%2Findex"
export * from "./divider-normal.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fdivider-normald57fe118%2Findex"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports